export const LEASE_END = 'b227141b-df66-4af2-9349-501a4eaf1ef5';
export const PAYMENT_FAILED = 'b1b2440c-7db0-41ff-b5ec-20a53ac16f66';
export const LEASE_SUMMARY = '6ad61327-b452-4c02-8c9f-d465bb705cb0';
export const LEASE_TERMS = '6e34f81b-6944-475b-81af-5c22c327c8ee';
export const IDENTITY_MISMATCH = '7360203b-060b-4e24-a9c1-f2adb42a3126';
export const INCOMPLETE_ONBOARDING = '2d950e64-cf9f-42a7-b787-16d6e6380997';
export const EVICTION = '52ad81b7-3077-4467-96bb-50b8acc24d08';
